import React from "react";

function TermsOfUse() {
  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <iframe
        src="https://appgenesisllc.com/termsofuse/"
        style={{ width: "100%", height: "100%", border: "none" }}
        title="Terms of Use"
      />
    </div>
  );
}

export default TermsOfUse;
